import { useEffect, useState } from 'react';
import { useWindowSize } from 'react-use';

import breakpointsStyle from '../stylesheets/bootstrap-vars.module.scss';

export const mobileMediaQuery = 'only screen and (max-width: 768px)';

// From bootstrap (strings w/ 'px' suffix)
export const BREAKPOINTS = {
  xs: '400px', // (not actually from bootstrap, we added this one)
  ...breakpointsStyle,
};

// From bootstrap (ints)
export const BREAKPOINT_VALUES = Object.fromEntries(
  Object.entries(BREAKPOINTS).map(([k, v]) => [k, parseInt(v, 10)]),
);

// window is not defined when running tests
const mediaQueryList = window.matchMedia(mobileMediaQuery);

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(mediaQueryList.matches);
  useEffect(() => {
    const handleResize = () => setIsMobile(mediaQueryList.matches);
    mediaQueryList.addEventListener('change', handleResize);
    return () => mediaQueryList.removeEventListener('change', handleResize);
  }, []);
  return isMobile;
};

/**
 * Given an array of allowed sizes, returns the current breakpoint size.
 *
 * sizes: array of strings, e.g. ['sm', 'md', 'lg', 'xl']
 */
export const useBreakpointSize = (sizes = ['xs', 'sm', 'md', 'lg', 'xl']) => {
  if (sizes.length === 0) throw new Error('Sizes array must not be empty.');

  // Get current window width
  const windowWidth = useWindowSize(window.innerWidth).width;

  // Use bootstrap breakpoints
  const { sm, md, lg, xl } = BREAKPOINT_VALUES;

  // Return the largest allowed size that's smaller than the window width
  if (xl < windowWidth && sizes.includes('xl')) return 'xl';
  if (lg < windowWidth && sizes.includes('lg')) return 'lg';
  if (md < windowWidth && sizes.includes('md')) return 'md';
  if (sm < windowWidth && sizes.includes('sm')) return 'sm';

  // If window width is smaller than all sizes, return the smallest allowed size
  if (sizes.includes('xs')) return 'xs';
  if (sizes.includes('sm')) return 'sm';
  if (sizes.includes('md')) return 'md';
  if (sizes.includes('lg')) return 'lg';
  return 'xl';
};

export const tableMediaQuery = `only screen and (max-width: 1450px)`;

export const getTableColumnMaxWidth = (numColumns) =>
  `clamp(var(--table-column-width), calc(100vw - ((${
    numColumns - 1
  } * var(--table-column-width)) + var(--side-panel-width))), 50vw)`;
